// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3Za_-","noInteraction":"EventWrapper_noInteraction__2VIfG"};